import script from "./AppsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsPanel.vue?vue&type=script&setup=true&lang=js"

import "../styles/appsPanel.css?vue&type=style&index=0&id=fbfb3bc6&scoped=true&lang=css&external"
import "../styles/tableAppsPanel.css?vue&type=style&index=1&id=fbfb3bc6&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbfb3bc6"]])

export default __exports__